import { render, staticRenderFns } from "./space_upload.vue?vue&type=template&id=72d81edf&"
import script from "./space_upload.vue?vue&type=script&lang=js&"
export * from "./space_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports